import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from "@angular/core";
import {
  MenuIconDisplay,
  toMenuIconDisplay,
} from "@app/core/utils/menu-icon.util";

@Component({
  selector: "app-menu-icon",
  host: {
    class: "menu-icon-host inline-flex shrink-0 items-center justify-center",
  },
  templateUrl: "./menu-icon.html",
  styleUrl: "./menu-icon.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuIcon {
  icon = input<string | undefined>();

  readonly display = computed<MenuIconDisplay>(() =>
    toMenuIconDisplay(this.icon()),
  );
}
